<template>
    <div id="register_page" class="page-class"
        :class="{'farmer': registerUserType == 'farmer', 'subdist': registerUserType == 'subdist', 'dist': registerUserType == 'dist', 'sale': registerUserType == 'sale'}">
        <div class="page-wrapper">
            <div class="page-content">
                <register-contact-number
                    v-if="registerState === 'contact_number'"
                    :lbl="lbl.register"
                    :modalController="modalController"
                    :theme="registerUserType"
                    @submitOtp="submitOtp($event)"
                    @onTracking="onTracking($event)"></register-contact-number>
                <!-- <register-user-type
                    v-if="registerState === 'user_type'"
                    :lbl="lbl.register"
                    :theme="registerUserType"
                    @selectUserType="selectUserType($event)"></register-user-type> -->
                <register-form
                    v-if="registerState === 'register_form'"
                    :lbl="lbl.register"
                    :contactNumber="contactNumber"
                    :modalController="modalController"
                    :busPage="busRegisterForm"
                    @register="register($event)"
                    @marketing="marketing($event)"
                    @clickBack="clickBack"></register-form>
            </div>

            <modal-master :controller="modalController" :theme="registerUserType"></modal-master>

            <div class="page-bg"
                :class="{'page-bg-white': registerState != 'register_form'}" ></div>
        </div>
    </div>
</template>
<script>
//basic
import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import Locale from '@/helper/locale/locale.js';
// import LineFunction from "@/helper/facede/LineFunction";
import { TrackingService } from "@/helper/TrackingHelper.js";
//component
import RegisterContactNumber from '@/module/Register/component/RegisterContactNumber.vue';
// import RegisterUserType from '@/module/Register/component/RegisterUserType.vue';
import RegisterForm from '@/module/Register/component/RegisterForm.vue';
//mixin
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import PDPAMixin from '@/mixin/PDPAMixin.js'
//core
// import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
// import { AuthDeviceLoginBuilder } from '@/core/Account/model/AuthConfigModel.js';

import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
//model
import { RegisterModel } from '../model/RegisterModel.js';
//service
import RegisterService from '../service/RegisterService';
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { OtpModalController } from "@/components/Modal/Controller/OtpModalController.js";
import { TermsModalController } from "@/components/Modal/Controller/TermsModalController.js";
import { RegisterSuccessModalController } from "@/components/Modal/Controller/RegisterSuccessModalController.js";
import { MarketingRegisterModalController } from "@/components/Modal/Controller/MarketingRegisterModalController.js";
import { AgeConsentModalController } from "@/components/Modal/Controller/AgeConsentModalController.js";

export default {
    name: 'register',
    components: {
        RegisterContactNumber,
        // RegisterUserType,
        RegisterForm,
        ModalMaster
    },
    mixins: [
        ErrorApiMixin,
        PDPAMixin
    ],
    computed: {
        registerState: function () {
            return this.$store.state.state;
            // return 'register_form';
        },
        registerUserType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),

            isLoading: false,

            isResgister: false,
            registerType: '', //line, pc
            welcomePoint: 0,
            getfriendRefcode: null,

            termVersion: '',
            privacyVersion: '',
            marketingVersion: '',
            pdpaConsent: {
                marketingOption: null,
                email: null,
                line: null,
                notification: null,
                sms: null,
                consentAge: 20
            },
            isEmail: true,
            isSMS: true,
            isLine: true,
            isNotification: true,
            consent: {},
            token: null,
            contactNumber: '',
            displayContactNumber: '',
            otp: null,
            otpModel: null,
            //bus
            busRegisterForm: new Vue(),
            //error handler
            errorHandler: null,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            confirmModal: new ConfirmModalController(),
            loadingModal: new LoadingModalController(),
            otpModal: new OtpModalController(),
            termsModal: new TermsModalController(),
            registerSuccessModal: new RegisterSuccessModalController(),
            marketingRegisterModal: new MarketingRegisterModalController(),
            ageConsentModal: new AgeConsentModalController(),

            trackingService: new TrackingService(this),
            trackingScreenName: 'register',
            trackingEventCategory: 'register_page'
        };
    },
    created: function() {
        this.initialRegister();
        BzbsPDPA.apiGetPDPAVersion()
            .then(res => {
                this.termVersion = res.data.terms.current_version;
                this.privacyVersion = res.data.privacy.current_version;
                this.marketingVersion = res.data.marketing.current_version;
            });
        //account
        Account.setLogout();
        Account.removeCacheCustom('BzbsIsFromLine');
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setConfirmModal(this.confirmModal);
        this.modalController.setOTPModal(this.otpModal);
        this.modalController.setTermsModal(this.termsModal);
        this.modalController.setRegisterSuccessModal(this.registerSuccessModal);
        this.modalController.setMarketingRegisterModal(this.marketingRegisterModal);
        this.modalController.setAgeConsentModal(this.ageConsentModal);

        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);
        this.errorHandler.setTitle(this.lbl.register.register_alert_headline);

        this.linkAccountHandler = new ErrorHandler();
        this.linkAccountHandler.setAlertModal(this.alertModal);
        this.linkAccountHandler.setTitle(this.lbl.register.register_alert_headline);

    },
    mounted: function () {
        this.trackingService.screenName(this.trackingScreenName);
        this.showLoading();

        setTimeout(() => {
            this.hideLoading();
        }, 750)
        // this.ageConsentModal.show();
    },
    methods: {
        //Event
        clickBack: function () {
            if (this.registerState == 'register_form')
                this.$store.commit('changeState', 'contact_number');
        },
        //initial
        initialRegister: function () {
            console.log(this.$route)
            this.registerType = this.$route.params.type || 'pc';
            this.$store.commit('changeUserType', 'farmer');

            this.getfriendRefcode = this.$route.query.getfriendRefcode || null;
        },
        submitOtp: function (data) {
            if (this.showLoading()) return;

            this.contactNumber = data.contactNumber;
            this.displayContactNumber = data.displayContactNumber;
            this.showOTP('register');
        },
        showOTP: function (channel) {
            this.trackingService.screenName('verifyotp');
            console.log('contactNumber',this.contactNumber);
            this.hideLoading();
            this.otpModal
                    .clearOtp()
                    .setTag('register-otp')
                    .setIntervalTime(60)
                    .setContactNumber(this.contactNumber)
                    .setRequestChannel(channel)
                    .startOtp();

            this.otpModal.onSubmitOTP((data) => {
                console.log('onSubmitOTP',data);
                // if (this.showLoading()) return;
                this.otpModal.hide();
                this.trackingService.event('verifyotp_page', 'click_verify_otp', null, null)

                var otp = {
                    contact_number: data.contact_number,
                    refcode: data.refcode,
                    otp: data.otp
                };
                this.otpModel = otp;
                this.otpSubmitted(otp);
                
            });
            this.otpModal.onClickClose(() => {
                this.hideLoading();
            })
            this.otpModal.onError((error) => {
                this.hideLoading();
                this.errorCase(error)
                console.log(error);
                
            })
        },
        //api
        otpSubmitted: async function (otp) {
            if (this.showLoading()) return;
            // this.showLoading();
            this.otp = otp;
            var data = await this.checkExistUserApi();
            this.checkExistUser(data);
        },
        checkExistUserApi: function () {
            return new Promise((resolve, reject) => {
                RegisterService.checkUserExist(this.otp)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        this.errorResponse(err, this.errorHandler);
                        reject(false);
                    });
            });
        },
        checkExistUser: function (data) {
            if (data.success) {
                console.log('success', data);
                this.isResgister = true;
                this.$store.commit('changeState', 'register_form');
                const userInfo = data.data;
                if (userInfo) {
                    this.$nextTick(()=> {
                        this.busRegisterForm.$emit('initialForm', {userInfo: userInfo, contactNumber: this.contactNumber});
                    });
                } else {
                    this.$nextTick(()=> {
                        this.busRegisterForm.$emit('initialForm', {contactNumber: this.contactNumber});
                    });
                }
                this.otpModal.hide();
                this.hideLoading();
            } else {
                if (data.code == "400" || data.code == 400) {
                    this.otpModal.hide();
                    this.alertModal
                        .setTitle(this.lbl.register.err_exist_user.title)
                        .setMsg(this.lbl.register.err_exist_user.msg)
                        .setBtnOk(this.lbl.default.close)
                        .show();
                    this.hideLoading();
                } else {
                    this.errorOtp(data);
                    this.hideLoading();
                }
            }
        },
        errorOtp: function(error) {
            this.otpModal.showError(error);
            // this.otpModal.show();
        },

        register: function (register) {
            if (this.showLoading()) return;

            const registerModel = new RegisterModel();
            if(this.getfriendRefcode){
                registerModel.setRefUserCode(this.getfriendRefcode)
            }
            this.pdpaConsent.terms = this.termVersion;
            this.pdpaConsent.privacy = this.privacyVersion;
            registerModel.setModel(register, this.otp, this.pdpaConsent,this.ref);

            const lineIdToken = Account.getCacheCustom('LineIdToken');
            registerModel.id_token = JSON.parse(lineIdToken);

            if (this.pdpaConsent.marketingOption != null) {
                Account.setCacheCustom('marketingConsent',
                    {
                        'marketingOption': this.pdpaConsent.marketingOption,
                        'email': this.pdpaConsent.email,
                        'sms': this.pdpaConsent.sms,
                        // 'notification': 0,
                        'line': this.pdpaConsent.line
                    }
                );
            }

            this.apiLineRegister(registerModel.getParams());
        },
        apiLineRegister: function(registerModel) {
            console.log(registerModel)
            RegisterService.registerLine(registerModel)
                .then((res) => {
                    this.registerSuccess(res.data.data.Data);
                    this.hideLoading();

                }).catch(err => {
                    this.errorResponse(err, this.errorHandler);
                    this.hideLoading();
                });
        },

        registerSuccess: async function (registerData) {
            let trace = null;
            if(registerData && registerData.buzzebees){
                trace = registerData.buzzebees.traces.filter((item) => {
                    return (item.Id.indexOf('CFFWelcomePoint') > -1 || item.Id.indexOf('CPFExistingWelcomePoint') > -1)
                })[0];
            }
            if(trace){
                if(trace.Points > 0){
                    this.registerSuccessModal
                        .clearText()
                        .setTitle(this.lbl.register.modal_welcome.title)
                        .setMsg(this.lbl.register.modal_welcome.message)
                        .setPoint(trace.Points)
                        .setTag('register-success')
                        .show();
                    this.registerSuccessModal.onClickOk((data) => {
                        if(data.tag == 'register-success'){
                            window.location.replace('/linelogin');
                        }
                    });
                }
            }else{
                this.registerSuccessModal
                    .clearText()
                    .setTitle(this.lbl.register.modal_register_success.title)
                    .setMsg(this.lbl.register.modal_register_success.message)
                    .setTag('register-success')
                    .show();
                this.registerSuccessModal.onClickOk((data) => {
                    if(data.tag == 'register-success'){
                        window.location.replace('/linelogin');
                    }
                });
            }
        },
        marketing: function(marketing) {
            console.log(marketing);

            this.pdpaConsent = {
                email: marketing.email == true ? 1 : 0,
                line: marketing.line == true ? 1 : 0,
                notification: marketing.notification == true ? 1 : 0,
                sms: marketing.sms == true ? 1 : 0,
                terms: this.termVersion,
                privacy: this.privacyVersion,
                consentAge: 20,
                marketingOption: parseInt(this.marketingVersion)
            }
            console.log(this.pdpaConsent);

        },

        //loading
        showLoading: function () {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        },
        errorCase: function(error) {
            let err = `${error.message}<br/>id:${error.id} & code:${error.code}`;
            this.alertModal
                .clearText()
                .setTitle(this.lbl.register.err_403.title)
                .setMsg(err)
                .setBtnOk(this.lbl.default.close)
                .setTag('txt-gray-3')
                .setBtnSecondary()
                .show();
        },
        onTracking: function (eventName) {
            console.log('onTrackingss',eventName);
            
            this.trackingService.event(this.trackingEventCategory, eventName, null, null)
        }
    }
}
</script>
<style lang="scss">
@import "@/module/Register/page/Register.scss";
</style>
